module.exports = __webpack_public_path__ + "img/chevron-right.e41bb48b.svg";